import { Notification, NotificationVariation } from '@salecycle/ui-component-library';
import * as React from 'react';
import { connect } from 'react-redux';
import { State } from 'store';
import { Actions } from './actions';

interface StateProps {
  visible: boolean;
  variation: NotificationVariation;
  detail?: string;
}

interface DispatchProps {
  closeNotification: () => void;
}

export type Props = StateProps & DispatchProps;

export const NotificationBar: React.FC<Props> = (props: Props) => (
  <Notification isOpen={props.visible} onChange={props.closeNotification} variation={props.variation}>
    {props.detail}
  </Notification>
);

export const mapStateToProps = (state: State): StateProps => ({
  visible: state.ui.notificationBar.visible,
  variation: state.ui.notificationBar.variation,
  detail: state.ui.notificationBar.detail,
});

const actions: DispatchProps = {
  closeNotification: Actions.closeNotification,
};

export default connect(mapStateToProps, actions)(NotificationBar);
